import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box } from '@mui/material';
import React from 'react';
/**
 * A UI component that renders a box with an icon and label.
 *
 * @param {AltchaBoxProp} root0 - Component props.
 * @param {React.ReactNode} root0.icon - The icon to display inside the box.
 * @param {string} root0.label - The text label to display next to the icon.
 * @returns {JSX.Element} JSX element.
 */
export const AltchaBox = ({ icon, label }) => {
    return (React.createElement(Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            width: 260,
            p: '0.7rem',
            border: `1px solid ${themeColors.border.main}`,
            borderRadius: '4px',
            backgroundColor: themeColors.surface.primary,
        } },
        icon,
        React.createElement(Box, { sx: { color: themeColors.text.main } }, label)));
};
